import {Map, fromJS} from 'immutable'

import {
  SET_CHAT_SETTINGS,
  SET_PLUGIN_SETTINGS,
  SET_CURRENT_USER, SET_CURRENT_USER_PRESENCE,
  SET_CURRENT_USER_ACTIVITY,
  SET_CURRENT_GUEST,
  SET_USERS, SET_PRESENCES,
  SET_TOP_EXPERTS,
  SET_USER_PRESENCE,
  SET_USER,
  SET_CONVERSATION_REFS,
  SET_RECENT_CONVERSATIONS,
  SET_RECENT_CONVERSATION_USER,
  SET_CONVERSATION_STACK,
  SET_TOTAL_CONV_MESSAGE_COUNT,
  SET_READ_CONV_MESSAGE_COUNT,
  SET_FOCUSED_CONVERSATION,
  SET_LAST_OPEN_TIME_FOR_CONVERSATION,
  SET_NEW_MESSAGE_NOTIFICATION,
  UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE,
  SET_NEW_MESSAGE,
  SET_PREVIOUS_MESSAGES,
  REMOVE_PREVIOUS_MESSAGES,
  UPDATE_MESSAGE_ATTR,
  SET_USER_SESSION_REFS,
  REMOVE_USER_SESSION_REF,
  SET_USER_SESSIONS,
  SET_USER_SESSIONS_COUNT,
  SET_SESSION,
  SET_SESSIONS,
  SET_CURRENT_SESSION,
  SET_SESSION_ACTIVITY,
  SET_SESSION_REQUEST,
  SET_SESSION_REQUESTS,
  SET_SESSION_CLAIMS,
  SHOW_MODAL,
  CLOSE_MODAL,
  CLOSE_ALL_MODALS,
  SET_CURRENT_PAYOUT_REQUEST,
  SET_PAYOUTS,
  ORDER_PAYOUTS,
  SET_CURRENT_USER_PAYOUTS,
  SET_CURRENT_CUSTOMER,
  SET_CURRENT_EXPERT_REVIEWS,
  SET_USER_SCHEDULE,
  SET_CHAT_LIST_TOGGLED,
  SET_CHAT_LIST_USER,
  REMOVE_CHAT_LIST_USER,
  CHANGE_CHAT_LIST_USER_ROLE,
  SET_CHAT_LIST_GUESTS,
  SET_GROUP_CHATS,
  SET_GROUP_CHAT,
  SET_GROUP_CHAT_ORDERS,
  SET_BOOKMARKED_GROUP_CHATS,
  REMOVE_BOOKMARKED_GROUP_CHAT,
  SET_SUBSCRIBED_GROUP_CHATS,
  REMOVE_SUBSCRIBED_GROUP_CHAT,
  SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT,
  REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT,
  SET_VIEWPORT_DIMENSIONS,
  SET_ADVERTISEMENTS
} from '../action_types'

import settingsReducer from './settings'
import pluginSettingsReducer from './plugin_settings'
import currentUserReducer from './current_user'
import currentGuestReducer from './current_guest'
import usersReducer from './users'
import chatListViewReducer from './chat_list_view'
import presencesReducer from './presences'
import chatListCountReducer from './chat_list_count'
import conversationsReducer from './conversations'
import recentConversationsReducer from './recent_conversations'
import notificationsReducer from './notifications'
import sessionsReducer from './sessions'
import messagesReducer from './messages'
import modalsReducer from './modals'
import currentPayoutRequestReducer from './current_payout_request'
import currentCustomerReducer from './current_customer'
import currentExpertReviewsReducer from './current_expert_reviews'
import payoutsReducer from './payouts'
import schedulesReducer from './schedules'
import topExpertsReducer from './top_experts'
import groupChatsReducer from './group_chats'
import viewportReducer from './viewport'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_CHAT_SETTINGS:
      return state.set(
        'chatSettings',
        settingsReducer(state.get('chatSettings'), action)
      )

    case SET_PLUGIN_SETTINGS:
      return state.set(
        'pluginSettings',
        pluginSettingsReducer(state.get('pluginSettings'), action)
      )

    case SET_CURRENT_USER:
    case SET_CURRENT_USER_PRESENCE:
    case SET_CURRENT_USER_ACTIVITY:
      return state
      .set(
        'currentUser',
        currentUserReducer(state.get('currentUser'), action)
      )
      .set(
        'users',
        usersReducer(state.get('users'), action)
      )
      .set(
        'chatListView',
        chatListViewReducer(state.get('chatListView'), action)
      )

    case SET_CURRENT_GUEST:
      return state.set(
        'currentGuest',
        currentGuestReducer(state.getIn('currentGuest'), action)
      )

    case SET_USERS:
      return state
      .set(
        'users',
        usersReducer(state.get('users'), action)
      )

    case SET_CHAT_LIST_USER:
    case REMOVE_CHAT_LIST_USER:
    case CHANGE_CHAT_LIST_USER_ROLE:
    case SET_CHAT_LIST_GUESTS:
      return state
        .set(
          'chatListView',
          chatListViewReducer(state.get('chatListView'), action)
        )
        .set(
          'chatListCount',
          chatListCountReducer(state.get('chatListCount'), action)
        )

    case SET_CHAT_LIST_TOGGLED:
      return state
        .setIn(['chatListState', 'isToggled'], action.toggled)

    case SET_TOP_EXPERTS:
      return state
        .set(
          'topExperts',
          topExpertsReducer(state.get('topExperts'), action)
        )

    case SET_USER:
      return state
      .set(
        'users',
        usersReducer(state.get('users'), action)
      )

    case SET_PRESENCES:
      return state
      .set(
        'presences',
        presencesReducer(state.get('presences'), action)
      )

    case SET_USER_PRESENCE:
      return state
      .set(
        'presences',
        presencesReducer(state.get('presences', action))
      )

    case SET_VIEWPORT_DIMENSIONS:
      return state
      .set(
        'viewport',
        viewportReducer(state.get('viewport'), action)
      )
      .set(
        'conversations',
        conversationsReducer(state.get('conversations'), action)
      )

    case SET_CONVERSATION_REFS:
    case SET_CONVERSATION_STACK:
    case SET_FOCUSED_CONVERSATION:
    case SET_LAST_OPEN_TIME_FOR_CONVERSATION:
    case SET_TOTAL_CONV_MESSAGE_COUNT:
    case SET_READ_CONV_MESSAGE_COUNT:
      return state
      .set(
        'conversations',
        conversationsReducer(state.get('conversations'), action)
      )

    case SET_RECENT_CONVERSATIONS:
    case SET_RECENT_CONVERSATION_USER:
      return state
      .set(
        'recentConversations',
        recentConversationsReducer(state.get('recentConversations'), action)
      )
      .set(
        'chatListView',
        chatListViewReducer(state.get('chatListView'), action)
      )

    case SET_NEW_MESSAGE_NOTIFICATION:
      return state
      .set(
        'notifications',
        notificationsReducer(state.get('notifications'), action)
      )
      .set('shouldShowNewMessageIndicatorOnMobile', true)

    case UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE:
      return state.set('shouldShowNewMessageIndicatorOnMobile', false)

    case SET_USER_SESSION_REFS:
    case REMOVE_USER_SESSION_REF:
    case SET_SESSION_ACTIVITY:
    case SET_SESSION_REQUEST:
    case SET_SESSION_REQUESTS:
    case SET_USER_SESSIONS:
    case SET_USER_SESSIONS_COUNT:
    case SET_SESSION:
    case SET_SESSIONS:
    case SET_CURRENT_SESSION:
    case SET_SESSION_CLAIMS:
      return state
      .set(
        'sessions',
        sessionsReducer(state.get('sessions'), action)
      )

    case SET_PREVIOUS_MESSAGES:
    case REMOVE_PREVIOUS_MESSAGES:
    case SET_NEW_MESSAGE:
    case UPDATE_MESSAGE_ATTR:
      return state
      .set(
        'messages',
        messagesReducer(state.get('messages'), action)
      )

    case SET_CURRENT_CUSTOMER:
      return state
      .set(
        'currentCustomer',
        currentCustomerReducer(state.get('currentCustomer'), action)
      )

    case SHOW_MODAL:
    case CLOSE_MODAL:
    case CLOSE_ALL_MODALS:
      return state
      .set(
        'modals',
        modalsReducer(state.get('modals'), action)
      )

    case SET_CURRENT_PAYOUT_REQUEST:
      return state
      .set(
        'currentPayoutRequest',
        currentPayoutRequestReducer(state.get('currentPayoutRequest'), action)
      )

    case SET_CURRENT_EXPERT_REVIEWS:
      return state
      .set(
        'currentExpertReviews',
        currentExpertReviewsReducer(state.get('currentExpertReviews'), action)
      )

    case SET_CURRENT_USER_PAYOUTS:
      return state
      .set(
        'currentUserPayouts',
        payoutsReducer(state.get('currentUserPayouts'), action)
      )

    case SET_PAYOUTS:
    case ORDER_PAYOUTS:
      return state
      .set(
        'payouts',
        payoutsReducer(state.get('payouts'), action)
      )

    case SET_USER_SCHEDULE:
      return state
      .set(
        'schedules',
        schedulesReducer(state.get('schedules'), action)
      )

    case SET_GROUP_CHATS:
    case SET_GROUP_CHAT_ORDERS:
    case SET_BOOKMARKED_GROUP_CHATS:
    case REMOVE_BOOKMARKED_GROUP_CHAT:
    case SET_SUBSCRIBED_GROUP_CHATS:
    case REMOVE_SUBSCRIBED_GROUP_CHAT:
    case SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
    case REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
      return state
      .set(
        'groups',
        groupChatsReducer(state.get('groups'), action)
      )
      .set(
        'chatListView',
        chatListViewReducer(state.get('chatListView'), action)
      )

    case SET_GROUP_CHAT:
      return state
      .set(
        'groups',
        groupChatsReducer(state.get('groups'), action)
      )

    case SET_ADVERTISEMENTS:
      return state
      .set('advertisements', fromJS(action.advertisements))

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/root.js
 **/